import { render, staticRenderFns } from "./lymsg.vue?vue&type=template&id=5c656b42&scoped=true&"
import script from "./lymsg.vue?vue&type=script&lang=js&"
export * from "./lymsg.vue?vue&type=script&lang=js&"
import style0 from "./lymsg.vue?vue&type=style&index=0&id=5c656b42&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c656b42",
  null
  
)

export default component.exports